import React from "react";
import styles from "./RiskProfile.module.scss";
import { useSelector } from "react-redux";
import MainLayout from "../../layouts/MainLayout/MainLayout";
import { useLocation, useParams } from "react-router-dom";
import useFetchOrganizationData from "../../actions/useFetchOrganizationData";
import { useTranslation } from "react-i18next";
import RiskProfileContent from "./RiskProfileContent";
import RiskProfileEditModal from "./RiskProfileEditModal";

const RiskProfile = () => {
  const { orgId } = useParams();
  const location = useLocation();
  const { t } = useTranslation();

  const modules = useSelector((state) => state.user.modules);
  const { risksData, findingsData, improvementsData, auditsData } = useSelector(
    (state) => state.organization,
  );

  // Fetch organization data when navigating through URL
  useFetchOrganizationData();

  // Extracting path from URL
  const lastIndex = location.pathname.lastIndexOf("/");
  const modifiedPath = location.pathname.substring(lastIndex);

  // Find the module object corresponding to the current path
  const currentModule = modules[orgId]?.find(
    (mod) => mod.path === modifiedPath,
  );

  return (
    <div>
      <MainLayout>
        <div className={styles.column}>
          <div className={styles.contentWrapper}>
            <RiskProfileContent
              title={t("riskProfile.title")}
              risksData={risksData}
              findingsData={findingsData}
              improvementsData={improvementsData}
              auditsData={auditsData}
            />
          </div>
        </div>
        <RiskProfileEditModal />
      </MainLayout>
    </div>
  );
};

export default RiskProfile;
